import React from 'react';
import { Box } from '@mui/material';

interface ContentWrapperProps {
    children: React.ReactNode;
}

const ContentWrapperArtist: React.FC<ContentWrapperProps> = ({ children }) => {

    return (
        <Box sx={{
            flexGrow: 1,
            px: { xs: 2, md: 4 },
            pt: 10,
            pb: 5,
            height: '100dvh',
            overflow: 'auto',
            maxWidth: '1600px',
            mx: 'auto',
        }}>
            {children}
        </Box>
    );
};

export default ContentWrapperArtist;
